export default __webpack_public_path__ + "static/media/lunchKeto.9ba376b6.svg";